import React, { useState } from "react";

import { useRouter } from "next/router";

import { Col, Progress, Timeline } from "antd";
import useTranslation from "next-translate/useTranslation";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

import ObjectIntlTranslator from "shared/components/atoms/ObjectIntlTranslator";
import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import getProgressColor from "shared/utils/getProgressColor";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { PlayCircleOutlined } from "@ant-design/icons";

import {
  CourseLesson,
  CourseModuleContainer,
  CourseModuleContent,
} from "./styles";

const SingleModule = ({ module, lessons, course }) => {
  const router = useRouter();
  const { lang } = useTranslation();

  const [showLessons, setShowLessons] = useState(false);

  const { state } = useGlobalContext();

  const mode = state.theme.value;
  const tenantData = state.tenancy;

  const toggleShowLessons = async () => setShowLessons(!showLessons);

  const handleAccessLesson = async (item) =>
    router.push(`/courses/${module.course_slug}/${module.slug}/${item.slug}`);

  return (
    <CourseModuleContainer className="course-module">
      <CourseModuleContent
        className="course-module-content"
        onClick={toggleShowLessons}
      >
        {showLessons ? (
          <FiChevronDown className="chevron" />
        ) : (
          <FiChevronRight className="chevron" />
        )}

        <span className="module-name-container">
          <ObjectIntlTranslator key="name" variable={module.name} lang={lang} />

          <span style={{ fontSize: 11 }}>
            <PlayCircleOutlined /> {module?.count_lessons}{" "}
            <StaticIntlTranslator id="common:lessons-m" />
          </span>
        </span>

        {course?.start_enrollment &&
          ((course?.is_author && course?.has_enrollment) ||
            !course?.is_author) && (
            <div className="progress-panel">
              <Progress
                type="circle"
                strokeColor={getProgressColor(tenantData, mode === "dark")}
                percent={module.complete_percentage}
                className={
                  module.complete_percentage >= 100 ? "progress-complete" : ""
                }
                width={42}
              />
            </div>
          )}
      </CourseModuleContent>
      {showLessons && (
        <Timeline>
          {lessons.data?.length > 0 && (
            <div>
              {lessons.data.map(
                (item) =>
                  item.status === "published" && (
                    <CourseLesson
                      key={item.id}
                      assisted={item.user_assisted}
                      onClick={() => handleAccessLesson(item)}
                    >
                      <Col span={24}>
                        <div className="lesson-title-container">
                          <span>
                            {item.title ? (
                              <ObjectIntlTranslator
                                variable={item.title}
                                lang={lang}
                              />
                            ) : (
                              "Unknown title"
                            )}
                          </span>

                          {item.content_access === "public" && (
                            <span className="public-badge">Pública</span>
                          )}
                        </div>
                      </Col>
                    </CourseLesson>
                  ),
              )}
            </div>
          )}
        </Timeline>
      )}
    </CourseModuleContainer>
  );
};

export default SingleModule;
